import { Injectable } from '@angular/core';
import { ModalService } from '@src/shared/modal/modal.service';
import { ServerEvents } from './StandardResponseService';
import { TranslationService } from './TranslationService';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  constructor(private translationService: TranslationService, private modalService: ModalService) {}

  process(
    event: { name: string },
    data?: {
      validation_error?: boolean;
      error?: string;
      messages?: string[][];
      details?: { field: string; values: string[] };
    },
  ): void {
    if (!data) {
      return;
    }
    if (data.validation_error) {
      if (event.name === ServerEvents.returnedUserError) {
        if (data.error && data.messages) {
          const translatedErrorMessages = data.messages.map((message) => {
            return message.map((errorPart) => {
              return this.dictionaryLookUpValidationError(errorPart);
            });
          });
          this.modalService.openError(this.dictionaryLookUp(data.error), ...translatedErrorMessages.flat());
        } else {
          console.error('Possibly unhandled validation error:', data);
        }
      }
    } else if (event.name === ServerEvents.serviceUnavailableError) {
      this.modalService.openError(this.dictionaryLookUp(event.name));
    } else if (data.error) {
      if (data.details?.values?.length) {
        this.modalService.openDetailedError(this.dictionaryLookUp(data.error), {
          'Berörda värden': data.details.values,
        });
      } else {
        this.modalService.openError(this.dictionaryLookUp(data.error));
      }
    } else {
      console.error('Incorrectly formatted user error response');
      console.error(data);
    }
  }

  showError(error: string): void {
    this.modalService.openError(this.dictionaryLookUp(error));
  }

  private dictionaryLookUp(status: string): string {
    const translatedMessage = this.translationService.convertError(status);
    return translatedMessage[0].toUpperCase() + translatedMessage.replace(/_/g, ' ').slice(1);
  }

  private dictionaryLookUpValidationError(status: string): string {
    return this.translationService.convertValidationError(status);
  }
}
